import './Sider.scss';

import { Drawer } from 'antd';
import Sider from 'antd/es/layout/Sider';

import { useUiContext } from '@/contexts/UiContext';

import SiderContent from './SiderContent';

const CustomSider = () => {
  const { openSider, setOpenSider, isMediumScreen } = useUiContext();
  const siderStyle: React.CSSProperties = {
    overflow: 'auto',
    height: '100dvh',
    position: 'sticky',
    insetInlineStart: 0,
    top: 0,
    bottom: 0,
  };

  return isMediumScreen ? (
    <Drawer
      open={openSider}
      className="LayoutDrawer"
      closable={false}
      maskClosable
      placement="left"
      width={250}
      onClose={() => setOpenSider(!openSider)}>
      <SiderContent />
    </Drawer>
  ) : (
    <Sider
      className="LayoutSider"
      collapsible
      collapsed={!openSider}
      width={250}
      style={{ backgroundColor: 'var(--layout-sider-bg-color)', ...siderStyle }}
      onCollapse={() => setOpenSider(!openSider)}>
      <SiderContent />
    </Sider>
  );
};

export default CustomSider;
